exports.isatty = function () { return false; };

function ReadStream() {
  throw new Error('tty.ReadStream is not implemented');
}
exports.ReadStream = ReadStream;

function WriteStream() {
  throw new Error('tty.ReadStream is not implemented');
}
exports.WriteStream = WriteStream;



/*****************
 ** WEBPACK FOOTER
 ** ./~/tty-browserify/index.js
 ** module id = 480
 ** module chunks = 0
 **/